import React, { useEffect } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Loader } from '@fiverr-private/feedback';
import { DrawerBody } from '@fiverr-private/overlay';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { AppI18n } from '../../i18n';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { Step } from '../../constants';

import final_image from '../../assets/final_image.svg';

const TIME_TILL_NEXT_STEP = 5000;

export const PreMigrationState = () => {
  const { setStep } = useBriefCreationContext();

  useEffect(() => {
    const timeout = async () => {
      await new Promise((resolve) => setTimeout(resolve, TIME_TILL_NEXT_STEP));
      setStep(Step.ProMigration);
    };

    timeout();

    // if we add setStep as a dependency it'll run this timeout a few times
    // leading to blank screen when opening the drawer after submiting the brief and closing it clicking the X button
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <DrawerBody>
        <Stack
          direction="column"
          height="100%"
          width="100%"
          alignItems="center"
          justifyContent="spaceBetween"
          paddingX="2"
        >
          <Stack direction="column" gap="8" alignItems="center" height="100%" justifyContent="center">
            <Image src={final_image} alt="final brief" width="320px" height="180px" />
            <Stack direction="column" alignItems="center" justifyContent="center">
              <Heading as="h5" size="h_sm" fontWeight="bold" textAlign="center">
                <AppI18n k="finish_step.pre_migration_state.title" />
              </Heading>
              <Text textAlign="center">
                <AppI18n k="finish_step.pre_migration_state.subtitle" />
              </Text>
            </Stack>
          </Stack>
          <Stack direction="row" gap="3" alignItems="center">
            <Loader size="lg" color="grey_1100" />
            <Typography color="grey_1000" fontWeight="semibold">
              <AppI18n k="finish_step.pre_migration_state.loading_text" />
            </Typography>
          </Stack>
        </Stack>
      </DrawerBody>
    </>
  );
};
